import React, { memo, useMemo } from 'react';
import { getContext, Symbols } from 'choerodon-ui/shared';
import { getPrefixCls } from '../configure/utils';
const FormContext = getContext(Symbols.FormContext, { getPrefixCls });
const BaseFormContextProvider = function FormContextProvider(props) {
    const { children, vertical, getPrefixCls: getGlobalPrefixCls } = props;
    const value = useMemo(() => ({
        vertical,
        getPrefixCls: getGlobalPrefixCls,
    }), [getGlobalPrefixCls, vertical]);
    return (React.createElement(FormContext.Provider, { value: value }, children));
};
BaseFormContextProvider.displayName = 'FormContextProvider';
export const FormContextProvider = memo(BaseFormContextProvider);
export default FormContext;
